<template lang="pug">
  footer(class="app-footer")
    img(class="hanshaw-logo" src="@/assets/logos/mathsmith-full-color-rgb-logo-only.svg" alt="MathSmith LLC" )
    p MathSmith is a creation of 
      <a href="/about">Tim Hanshaw.</a> <br> Copyright &copy; {{ fullYear }} MathSmith LLC. All rights reserved.
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      fullYear: new Date().getFullYear()
    };
  }
};
</script>
